
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
import * as ListerSpeakingLanguagesBadge from "concepts/listings/feature/lister_speaking_languages/badge_with_popover"
import Report_btn from "concepts/listings/problems/reports/new_report/button/index"
import ListingsShareBar from "concepts/listings/share/bar/index"
// endregion Public Components

// region Private Components
import CopyListingReferenceButton from "./components/copy_listing_reference_button/index"
import Tracking from "./components/tracking/index"
import ListerInternalRemark from "./components/lister_internal_remark/index"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "page--single-listings-detail-page--main-section"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)
    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    CopyListingReferenceButton.create({scope: $el})
    Tracking.track($el)
    Report_btn.init()
    ListerSpeakingLanguagesBadge.initAllMatchingElements()
    ListingsShareBar.create()
    ListerInternalRemark.create({scope: $el})
  })
}

export default{
  init,
}
